/* eslint-disable no-unused-expressions */
import React from "react";
import './CreatePostControlInfoCorrections.scss';
import * as PropertyBucket from '../../Properties/Properties';
import {CorrectionDto} from '../Dtos/CorrectionDto';
import PopUp from '.././PopUp/PopUp';
import * as validator from "../Validators/ControlValidator.js";
import SelectCustom from "../SelectCustom/SelectCustom";
import Input from '../Input/Input';
import TableCustom from "../TableCustom/TableCustom";
import {
  correctionKindDict, prepareCorrectionTableArray,
  formatCurrency,
  influenceDict
} from "../ControlStateHelper";
import {draftjsToString} from '../WysiwygEditor/WysiwygHelpers';


class CreatePostControlInfoCorrections extends React.Component {

   constructor(props) {
             super(props);
             this.state = {
                     isWaiting: false,
                     showPopup: false,
                     classesProjectNumber:[],
                     classesFinding:[],
                     classesPaymentClaim:[],
                     classesOrder:[],
                     classesKind:[],
                     classesBase:[],
                     classesBaseError:null,
                     classesRate:[],
                     classesRateError:null,
                     classesWrongExpenditure:[],
                     classesWrongExpenditureError:null,
                     classesCurrentInfluence:[],
                     classesFutureInfluence:[],
                 columns: [
                     {title: 'Numer ustalenia', field: 'findingNumber', width: 40, cellStyle: {textAlign: 'center'}},
                     {title: 'Typ ustalenia', field: 'findingKind', minWidth: 90, cellStyle: { wordBreak: 'break-word'}},
                     {title: 'Korekta kosztów pośrednich', field: 'indirectCostsDisplay', width: 80, cellStyle: {textAlign: 'center'}},
                     {title: 'Rodzaj korekty', field: 'kind', width: 80},
                     {title: 'Stawka korekty', field: 'rateFormatted', width: 90, cellStyle: {textAlign: 'right'}},
                     {title: 'Podstawa korekty', field: 'baseFormatted', width: 110, cellStyle: {textAlign: 'right'}},
                     {
                         title: 'Kwota wydatków niekwalifikowalnych',
                         field: 'wrongExpenditureFormatted',
                         width: 110,
                         cellStyle: {textAlign: 'right'}
                     },
                     {
                         title: 'Projekt',
                         field: 'projectNumber',
                         width: 110,
                         cellStyle: {textAlign: 'right'}
                     },
                     {
                         title: 'Wniosek o płatność',
                         field: 'number',
                         width: 110,
                         cellStyle: {textAlign: 'center'}
                     },
                     {
                         title: 'Zamówienie publiczne',
                         field: 'orderNumber',
                         width: 110,
                         cellStyle: {textAlign: 'center', wordBreak: 'break-word'}
                     },
                 ],
             };
             this.projectNumberSelectRef = React.createRef();
             this.finantialSelectRef = React.createRef();
             this.paymentClaimSelectRef = React.createRef();
             this.orderSelectRef = React.createRef();
             this.correctionKindSelectRef = React.createRef();
             this.influenceSelectRef = React.createRef();
             this.influenceFutureSelectRef = React.createRef();

             this.handleClosePopUp = this.handleClosePopUp.bind(this);
   }

   shouldComponentUpdate(nextProps, nextState){
            if(this.props.findings !== nextProps.findings){
                return true;
            }
            if(this.state !== nextState){
                return true;
            }
            return false;
   }

   handleChange = (e) => {
       let prevCorrectionData = this.state.correctionData;
       let correctionData;
       let wrongExpenditure = null;
       e.target.name === 'rate' ? wrongExpenditure = this.handleChangeWrongExpenditure(prevCorrectionData.base, this.stringToFloat(e.target.value)) : null;
       e.target.name === 'base' ? wrongExpenditure = this.handleChangeWrongExpenditure(this.stringToFloat(e.target.value), prevCorrectionData.rate) : null;
       if (wrongExpenditure === null) {
           correctionData = {
               ...this.state.correctionData,
               [e.target.name]: this.stringToFloat(e.target.value),
               [e.target.name + "Formatted"]: e.target.value
           };
       } else {
           correctionData = {
               ...this.state.correctionData,
               [e.target.name]: this.stringToFloat(e.target.value),
               [e.target.name + "Formatted"]: e.target.value,
               wrongExpenditure: wrongExpenditure,
               wrongExpenditureFormatted: this.currencyFormat(wrongExpenditure, 2)
           };
       }

       this.setState({correctionData: correctionData});
   };

    handleChangeWrongExpenditure = (base, rate) => {
        if (base > 0 && rate > 0) {
            let wrongExpenditure = (base * rate / 100);
            return wrongExpenditure;
        }
    };

    setProjectNumberValues = (values) => {
        const projectNumber = values && values.length > 0 ? values[0].number : null;
        let correctionData = {
            ...this.state.correctionData,
            projectNumber
        };
        this.setState({ correctionData });
    };
    setFindingValues = (values) => {
        let findingKind = values && values.length > 0 && values[0].findingKind ? values[0].findingKind.code + " " + values[0].findingKind.name : '';
        let correctionData = {...this.state.correctionData, finding: values, findingKind: findingKind};
        this.setState({correctionData: correctionData});
    };
    setPaymentClaimValues = (values) => {
        let correctionData = {...this.state.correctionData, paymentClaim: values};
        this.setState({correctionData: correctionData});
    };
    setOrderValues = (values) => {
        let correctionData = {...this.state.correctionData, order: values};
        this.setState({correctionData: correctionData});
    };
    setCorrectionKindValues = (values) => {
        let correctionData = values.length > 0 && values[0].option === "wskaźnikowa" ? {
            ...this.state.correctionData,
            kindOption: values
        } : {
            ...this.state.correctionData,
            kindOption: values,
            rate: null,
            rateFormatted: '',
            base: null,
            baseFormatted: ''
        };
        this.setState({correctionData: correctionData});
    };
    setInfluenceCurrentValues = (values) => {
        let correctionData = {...this.state.correctionData, influenceCurrentOption: values};
        this.setState({correctionData: correctionData});
    };
    setInfluenceFutureValues = (values) => {
        let correctionData = {...this.state.correctionData, influenceFutureOption: values};
        this.setState({correctionData: correctionData});
    };

   handleClosePopUp(){
          this.setState({showPopup: false});
   }

    isWaitingOnOff = (OnOff) => {
        this.setState({
            isWaiting: OnOff
        })
    };

    showPopup = (title, notification, type, onClickEvent) => {
        this.setState({
            showPopup: true,
            popUp: {title: title, notification: notification, type: type, onClickEvent: onClickEvent}
        })

    };

    currencyFormat = (number, fractionDigits) => {
       return formatCurrency(number, fractionDigits)
    };

    stringToFloat = (string) => {
        return parseFloat(string.replace(',', '.').replace(/\s+/g, ''));
    };

   prepareCorrectionsData = (findings, orders) => prepareCorrectionTableArray(findings, orders)

    onAddButtonClick = () => {
        this.showEditWindow();
    };

    onEditButtonClick = (row) => {
        this.showEditWindow(row);
    };


    onDeleteButtonClick = (row) => {
        this.showPopup("Komunikat", PropertyBucket.deleteCorrectionConfirmationMessage(), "confirm", () => {
            this.deleteCorrection(row)
        })
    };

   showActionsWindow = () => {
        let row = this.state.correctionData;
       return (
           <PopUp
               customContent
               handleClosePopup={this.closeWindow}
               title={this.state.showEditTab && (row === undefined || row.id === undefined) ? 'Dodawanie korekty' : 'Edycja korekty'}
               scrolled
           >
               <>{this.state.showEditTab ? this.displayEditTab() : null}</>
           </PopUp>
       )
   };

    showEditTab = () => {
        this.setState({
            showEditTab: true,
        });
    };

    showEditWindow = (row) => {
        if (row && row.findingKind) {
            (row.findingKind = row.finding[0].findingKind ? row.finding[0].findingKind.code + " " + row.finding[0].findingKind.name : null)
        }
        this.setState({
            showWindow: true,
            correctionData: row,
        });
        this.showEditTab();
    };

    closeWindow = () => {
        this.setState({
           showEditTab: false,
            showWindow: false,
            classesProjectNumber: [],
            classesFinding: [],
            classesPaymentClaim: [],
            classesOrder: [],
            classesKind: [],
            classesBase: [],
            classesRate: [],
            classesWrongExpenditure: [],
            classesCurrentInfluence: [],
            classesFutureInfluence: [],
        });
    };

    displayEditTab = () => {
            let row = this.state.correctionData;
            let findings = this.props.findings;
            let paymentClaims = this.props.paymentClaims;
            let orders = this.props.orders;
            let editWindow;
            let disabledSave;
            let disabled;
            disabledSave = row === undefined || findings === undefined || findings.length===0;
            disabled = row === undefined || (row!==undefined && (row.kindOption===undefined || (row.kindOption && row.kindOption.length===0))) || (row!==undefined && row.kindOption && row.kindOption.length>0 && row.kindOption[0].option!=="wskaźnikowa");
            editWindow =    <div id = "editWindowTab">
                                 <div className="row">
                                    <div className="col-md-12">
                                        {this.renderProjectNumberSelect(this.props.projectNumbers, row!==undefined ? row.projectNumber  : null)}
                                    </div>
                                </div>
                                 <div className="row">
                                    <div className="col-md-6">
                                        {this.renderFindingSelect(findings, row!==undefined && row.finding && row.finding.length>0 ? row.finding[0] : null)}
                                    </div>
                                    <div className="col-md-6">
                                        <Input
                                            label='Typ ustalenia finansowego'
                                            labelClassName='mt-3 font-weight-bold'
                                            defaultValue={row!==undefined ? row.findingKind : ""}
                                            readOnly
                                            disabled
                                            inputId='findingKindInputId'
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mt-3">
                                            <label className="font-weight-bold d-flex align-items-center">
                                                <input
                                                    type="checkbox"
                                                    checked={row !== undefined && row.indirectCosts === true}
                                                    onChange={(e) => {
                                                        let correctionData = {...this.state.correctionData, indirectCosts: e.target.checked};
                                                        this.setState({correctionData: correctionData});
                                                    }}
                                                    style={{marginRight: '8px'}}
                                                />
                                                Korekta kosztów pośrednich
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        {this.renderPaymentClaimSelect(paymentClaims, row!==undefined ? row.number : null)}
                                    </div>
                                    <div className="col-md-6">
                                        {this.renderOrderSelect(orders, row!==undefined ? row.orderNumber : null)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        {this.renderCorrectionKindSelect(row!==undefined ? row.kind : null)}
                                    </div>
                                    <div className="col-md-6">
                                        {this.renderInput("rate", row!==undefined ? row.rateFormatted : "", this.state.classesRate, disabled, 'Stawka korekty', this.state.classesRateError)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        {this.renderInput("base", row!==undefined ? row.baseFormatted : "", this.state.classesBase, disabled, 'Podstawa korekty', this.state.classesBaseError)}
                                    </div>
                                    <div className="col-md-6">
                                        {this.renderInput("wrongExpenditure", row!==undefined ? row.wrongExpenditureFormatted : "", this.state.classesWrongExpenditure, false, 'Wydatki niekwalifikowalne', this.state.classesWrongExpenditureError)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        {this.renderCurrentInfluenceSelect(row!==undefined ? row.influenceCurrent : null)}
                                    </div>
                                    <div className="col-md-6">
                                        {this.renderFutureInfluenceSelect(row !== undefined ? row.influenceFuture : null)}
                                    </div>
                                </div>
                <div className="btn_group mb-2">
                    <button className="btn save-btn" id="save_button" onClick={() => this.saveCorrection(row)}
                            disabled={disabledSave}>ZAPISZ
                    </button>
                    <button className="btn cancel-btn" onClick={() => this.closeWindow()}>ANULUJ</button>
                </div>
            </div>;
        return editWindow;
    };

    prepareFindingOptions = (data) => {
        if (data && data.length > 0) {
            data.forEach((data) => {
                data.option = data.number + " " + draftjsToString(data.title);
            })
        }

    };

    renderInput = (name, value, classes, disabled, label, error) => {
        return (
            <Input
                containerClassName={classes.join(' ')}
                label={label}
                labelClassName='mt-3 font-weight-bold'
                inputId={name}
                name={name}
				maxLength={17}
				chartCounterClassName={"hiddenElement"}
                value={value !== null ? value : ''}
                disabled={disabled}
                onChange={(e)=>{this.handleChange(e)}}
                errorId={name + "Alert"}
                error={error}
                errorClassName='error-position'
                onKeyPress={(event) => {
                    if (!/[0-9_,_.]/.test(event.key)) {
                        event.preventDefault();
                    }
                }}
            />
        )
    };

    renderProjectNumberSelect = (projectNumbers, option) =>{
        let projectNumbersDropdown;
        const projectNumberOptions = projectNumbers.map(project => ({
                label: project,
                number: project
        }));
        if(projectNumbers && projectNumbers.length > 0 ) {
            projectNumbersDropdown = <div>
                <div id="finding_select" className={this.state.classesProjectNumber.join(' ')}>
                    <SelectCustom
                        values={projectNumberOptions.filter(value => value?.number === option)}
                        labelField="label"
                        placeholder=""
                        valueField="number"
                        options={projectNumberOptions}
                        onChange={(values) => this.setProjectNumberValues(values)}
                        id='projectNumberSelectId'
                        dropdownId='projectNumberDropdownId'
                        label='Projekt'
                        labelClassName='mt-3 font-weight-bold'
                        parentRef={this.projectNumberSelectRef}
                     />
                </div>
                <div id="projectNumberAlert" className="red"></div>
            </div>
        } else projectNumbersDropdown = (
            <>
                <p className="empty-label">Projekt</p>
                <p>Brak projektów</p>
            </>
        );
        return projectNumbersDropdown
    };

    renderFindingSelect = (findings, option) =>{
        let findingDropdown;

        this.prepareFindingOptions(findings);

        const values = findings.filter(value => option != null && (value.id === option.id || option.pseudoId != null && option.pseudoId === value.pseudoId));

        if(findings && findings.length > 0 ) {
            findingDropdown = <div>
                <div id="finding_select" className={`financial-select ${this.state.classesFinding.join(' ')}`}>
                    <SelectCustom
                        values={values}
                        labelField="option"
                        placeholder=""//Ustalenie finansowe
                        valueField="option"
                        options={findings}
                        onChange={(values) => this.setFindingValues(values)}
                        id='finantialSelectId'
                        dropdownId='finantialDropdownId'
                        label='Ustalenie finansowe'
                        labelClassName='mt-3 font-weight-bold'
                        parentRef={this.finantialSelectRef}
                     />
                </div>
                <div id="findingAlert" className="red"></div>
            </div>
        } else findingDropdown = (
            <>
                <p className="empty-label">Ustalenie finansowe</p>
                <p>Brak ustaleń finansowych</p>
            </>
        );
        return findingDropdown
    };

    renderPaymentClaimSelect = (paymentClaims, option) =>{
        let paymentClaimsDropdown;

        if(paymentClaims && paymentClaims.length > 0 ) {
              paymentClaimsDropdown = <div id = "order_select" className = {this.state.classesPaymentClaim.join(' ')}>
                <SelectCustom
                    values={paymentClaims.filter(value => value.number === option)}
                    labelField="number"
                    placeholder=""//Wniosek o płatność
                    valueField="number"
                    options={paymentClaims}
                    onChange={(values) => this.setPaymentClaimValues(values)}
                    id='paymentClaimSelectId'
                    dropdownId='paymentClaimDropdownId'
                    label='Wniosek o płatność'
                    labelClassName='mt-3 font-weight-bold'
                    parentRef={this.paymentClaimSelectRef}
                />
              </div>
        } else paymentClaimsDropdown = (
            <>
                <p className="empty-label">Wniosek o płatność</p>
                <p>Brak wniosków o płatność</p>
            </>
        );
        return paymentClaimsDropdown
    };

    renderOrderSelect = (orders, option) =>{
        let orderDropdown;

        if(orders && orders.length > 0 ) {
            orderDropdown = <div id = "order_select" className = {this.state.classesOrder.join(' ')}>
                <SelectCustom
                    values={orders.filter(value => value?.orderNumber === option)}
                    labelField="orderNumber"
                    placeholder=""//Zamówienie publiczne
                    valueField="orderNumber"
                    options={orders}
                    onChange={(values) => this.setOrderValues(values)}
                    id='orderSelectId'
                    dropdownId='orderDropdownId'
                    label='Zamówienie publiczne'
                    labelClassName='mt-3 font-weight-bold'
                    parentRef={this.orderSelectRef}
                />
            </div>
        } else orderDropdown = (
            <>
                <p className="empty-label">Zamówienie publiczne</p>
                <p>Brak zamówień publicznych</p>
            </>
        );
        return orderDropdown
    };

    renderCorrectionKindSelect = (option) => {
        let correctionKindDropdown;
        let options = [{ordinal: 0, option: "dyferencyjna"}, {ordinal: 1, option: "wskaźnikowa"}, {
            ordinal: 2,
            option: "inna"
        }];

        correctionKindDropdown = <div>
            <div id="finding_select" className={this.state.classesKind.join(' ')}>
                <SelectCustom
                    values={options.filter(value => value.option === option)}
                    labelField="option"
                    placeholder=""//Rodzaj korekty
                    valueField="option"
                    errorId='kindAlert'
                    options={options}
                    onChange={(values) => this.setCorrectionKindValues(values)}
                    id='correctionKindSelectId'
                    dropdownId='correctionKindDropdownId'
                    label='Rodzaj korekty finansowej'
                    labelClassName='mt-3 font-weight-bold'
                    parentRef={this.correctionKindSelectRef}
                />
            </div>
        </div>;

        return correctionKindDropdown
    };

    renderCurrentInfluenceSelect = (option) => {
        let currentInfluenceDropdown;
        let options = [{ordinal: 0, option: "TAK"}, {ordinal: 1, option: "NIE"}, {ordinal: 2, option: "ND"}];

        currentInfluenceDropdown = <div>
            <div id="finding_select" className={this.state.classesCurrentInfluence.join(' ')}>
                <SelectCustom
                    values={options.filter(value => value.option === option)}
                    labelField="option"
                    placeholder=""//Wpływ na inne złożone wnioski o płatność
                    valueField="option"
                    options={options}
                    onChange={(values) => this.setInfluenceCurrentValues(values)}
                    id='influenceSelectId'
                    dropdownId='influenceDropdownId'
                    label='Wpływ na inne złożone wnioski o płatność'
                    labelClassName='mt-3 font-weight-bold'
                    parentRef={this.influenceSelectRef}
                    errorId='currentInfluenceAlert'
                />
            </div>
        </div>;

        return currentInfluenceDropdown
    };

    renderFutureInfluenceSelect = (option) => {
        let futureInfluenceDropdown;
        let options = [{ordinal: 0, option: "TAK"}, {ordinal: 1, option: "NIE"}, {ordinal: 2, option: "ND"}];


        futureInfluenceDropdown = <div>
            <div id="finding_select" className={this.state.classesFutureInfluence.join(' ')}>
                <SelectCustom
                    values={options.filter(value => value.option === option)}
                    labelField="option"
                    placeholder=""//Potencjalny wpływ na przyszłe wnioski
                    valueField="option"
                    options={options}
                    onChange={(values) => this.setInfluenceFutureValues(values)}
                    id='influenceFutureSelectId'
                    dropdownId='influenceFutureDropdownId'
                    label='Potencjalny wpływ na przyszłe wnioski'
                    labelClassName='mt-3 font-weight-bold'
                    parentRef={this.influenceFutureSelectRef}
                    errorId='futureInfluenceAlert'
                />
            </div>
        </div>;
        return futureInfluenceDropdown
    };

    handleAlertBorder = (validated, className, newClasses, areAllFieldsPassed) => {
        if(validated) {
                       let index = newClasses.indexOf("alertBorder");
                       areAllFieldsPassed ? areAllFieldsPassed = true : null;
                       if(index !== -1) {
                            newClasses.splice(index, 1);
                           this.setState({[className]: newClasses});
                       }
        } else {
            areAllFieldsPassed = false;
            if (!newClasses.includes("alertBorder")) {
                newClasses.push("alertBorder");
            }
            this.setState({[className]: newClasses})
        }
        return areAllFieldsPassed;
    };

    validateCorrection = (correctionData) => {
            let areAllFieldsPassed = true;

            let isProjectNumberChosen = validator.getMustBeChecked(correctionData.projectNumber, "projectNumberAlert", PropertyBucket.getProjectNumberMustBeChosenMessage());
            areAllFieldsPassed = this.handleAlertBorder(isProjectNumberChosen, "classesProjectNumber", this.state.classesProjectNumber, areAllFieldsPassed);

            let isFindingChosen = validator.getMustBeChecked(correctionData.finding, "findingAlert", PropertyBucket.getFindingMustBeChosenMessage());
            areAllFieldsPassed = this.handleAlertBorder(isFindingChosen, "classesFinding", this.state.classesFinding, areAllFieldsPassed);

            let isKindChosen = validator.getMustBeChecked(correctionData.kindOption, "kindAlert", PropertyBucket.getCorrectionKindMustBeChosenMessage());
            areAllFieldsPassed = this.handleAlertBorder(isKindChosen, "classesKind", this.state.classesKind, areAllFieldsPassed);

            if(correctionData.kindOption?.find(el => el.option === "wskaźnikowa")) {
                let isRateChosen = validator.getMustBeChecked(correctionData.rate, "rateAlert", PropertyBucket.getRateMustBeFilledOutMessage());
                let isRateValidated = validator.getRateMustByBetweenZeroAndHundred(correctionData.rate, "rateAlert", PropertyBucket.getRateMustByBetweenZeroAndHundredMessage());
                let isRateNumeric = validator.getMustNumeric(correctionData.rateFormatted, "rateAlert", PropertyBucket.getMustNumericMessage());
                areAllFieldsPassed = this.handleAlertBorder(isRateChosen && isRateNumeric && isRateValidated, "classesRate", this.state.classesRate, areAllFieldsPassed);

                if (!isRateChosen) this.setState({classesRateError: PropertyBucket.getRateMustBeFilledOutMessage()});
                else if (!isRateValidated) this.setState({classesRateError: PropertyBucket.getRateMustByBetweenZeroAndHundredMessage()});
                else if (!isRateNumeric) this.setState({classesRateError: PropertyBucket.getMustNumericMessage()});
                else this.setState({classesRateError: null});

                let isBaseChosen = validator.getMustBeChecked(correctionData.base, "baseAlert", PropertyBucket.getBaseMustBeFilledOutMessage());
                let isBaseNumeric = validator.getMustNumeric(correctionData.baseFormatted, "baseAlert", PropertyBucket.getMustNumericMessage());
                let isBaseGreaterThanZero = validator.getMustBeGreaterThan(correctionData.base, 0, "baseAlert", PropertyBucket.getMustBeGreaterThanZeroMessage());
                areAllFieldsPassed = this.handleAlertBorder(isBaseChosen && isBaseNumeric && isBaseGreaterThanZero, "classesBase", this.state.classesBase, areAllFieldsPassed);

                if (!isBaseChosen) this.setState({classesBaseError: PropertyBucket.getBaseMustBeFilledOutMessage()});
                else if (!isBaseNumeric) this.setState({classesBaseError: PropertyBucket.getMustNumericMessage()});
                else if (!isBaseGreaterThanZero) this.setState({classesBaseError: PropertyBucket.getMustBeGreaterThanZeroMessage()});
                else this.setState({classesBaseError: null})
            } else {
                this.setState({classesRateError: null});
                areAllFieldsPassed = this.handleAlertBorder(true, "classesRate", this.state.classesRate, areAllFieldsPassed);
                this.setState({classesBaseError: null});
                areAllFieldsPassed = this.handleAlertBorder(true, "classesBase", this.state.classesBase, areAllFieldsPassed);
            }

        let isWrongExpenditureChosen = validator.getMustBeChecked(correctionData.wrongExpenditure, "wrongExpenditure", PropertyBucket.getWrongExpenditureMustBeFilledOutMessage());
        let isWrongExpenditureGreaterThanZero = validator.getMustBeGreaterThan(correctionData.wrongExpenditure, 0, "wrongExpenditure", PropertyBucket.getMustBeGreaterThanZeroMessage());
        let isBaseGreaterThanExpenditure = true;
        if (correctionData.base !== null) {
            isBaseGreaterThanExpenditure = validator.getMustBeGreaterThan(correctionData.base, correctionData.wrongExpenditure, "wrongExpenditure", PropertyBucket.getBaseMustBeGreaterThanWrongExpenditureMessage())
        }
        let isWrongExpenditureNumeric = validator.getMustNumeric(correctionData.wrongExpenditureFormatted, "wrongExpenditure", PropertyBucket.getMustNumericMessage());
        areAllFieldsPassed = this.handleAlertBorder(isWrongExpenditureChosen && isWrongExpenditureNumeric && isWrongExpenditureGreaterThanZero && isBaseGreaterThanExpenditure, "classesWrongExpenditure", this.state.classesWrongExpenditure, areAllFieldsPassed);

        if (!isWrongExpenditureChosen) this.setState({classesWrongExpenditureError: PropertyBucket.getWrongExpenditureMustBeFilledOutMessage()});
        else if (!isWrongExpenditureNumeric) this.setState({classesWrongExpenditureError: PropertyBucket.getMustNumericMessage()});
        else if (!isWrongExpenditureGreaterThanZero) this.setState({classesWrongExpenditureError: PropertyBucket.getMustBeGreaterThanZeroMessage()});
        else if (!isBaseGreaterThanExpenditure) this.setState({classesWrongExpenditureError: PropertyBucket.getBaseMustBeGreaterThanWrongExpenditureMessage()});
        else this.setState({classesWrongExpenditureError: null});

        let isCurrentInfluenceChosen = validator.getMustBeChecked(correctionData.influenceCurrentOption, "currentInfluenceAlert", PropertyBucket.getCurrentInfluenceMustBeChosenMessage());
        areAllFieldsPassed = this.handleAlertBorder(isCurrentInfluenceChosen, "classesCurrentInfluence", this.state.classesCurrentInfluence, areAllFieldsPassed);

        let isFutureInfluenceChosen = validator.getMustBeChecked(correctionData.influenceFutureOption, "futureInfluenceAlert", PropertyBucket.getFutureInfluenceMustBeChosenMessage());
        areAllFieldsPassed = this.handleAlertBorder(isFutureInfluenceChosen, "classesFutureInfluence", this.state.classesFutureInfluence, areAllFieldsPassed);

        return areAllFieldsPassed;
    };

    saveCorrection = (row) => {
        let correctionData = this.state.correctionData;
        let areAllFieldsPassed = this.validateCorrection(correctionData);
        if (areAllFieldsPassed){
            this.props.isWaitingOnOff(true);
            let id = row.id !== undefined ? row.id : null;
            let pseudoId = id === null ? Date.now() : null;

            let correctionDto = new CorrectionDto();
            correctionDto.pseudoId = pseudoId;
            correctionDto.rate = correctionData.rate;
            correctionDto.base = correctionData.base;
            correctionDto.wrongExpenditure = correctionData.wrongExpenditure;
            correctionDto.kind = correctionData.kindOption ? correctionData.kindOption[0].option : null;
            correctionDto.paymentClaim = correctionData.paymentClaim ? correctionData.paymentClaim[0] : null;
            correctionDto.pseudoId = Date.now();
            correctionDto.projectNumber = correctionData.projectNumber;

            // MFIPRM-3247
            if(correctionData.order === 'brak' || correctionData.order == null) {
                correctionDto.order = null;
            } else {
                correctionDto.order = correctionData.order[0];
            }

            correctionDto.influenceCurrent = correctionData.influenceCurrentOption ? correctionData.influenceCurrentOption[0].option : null;
            correctionDto.influenceFuture = correctionData.influenceFutureOption ? correctionData.influenceFutureOption[0].option : null;
            // Dla nowych korekt domyślnie false, dla istniejących bez wartości null
            correctionDto.indirectCosts = typeof correctionData.indirectCosts === 'boolean'
                ? correctionData.indirectCosts
                : (row.id === undefined ? false : null);

            let findings = [...this.props.findings];

            findings.forEach((finding) => {
                if(row.id || row.pseudoId) {
                    finding.corrections.forEach((correction, index) => {
                        if(row.id != null && correction.id === row.id || row.pseudoId != null && correction.pseudoId === row.pseudoId) {
                            finding.corrections[index].toRemove = true;
                        }
                    })
                }

                if(finding.id === row.finding[0].id) {
                    finding.corrections.push(correctionDto);
                    this.props.onCorrectionsChange(findings);
                    this.closeWindow();
                    this.props.isWaitingOnOff(false);
                    this.showPopup("Komunikat", PropertyBucket.saveCorrectionMessage(), "notify")
                }
            })
        }
    };

    deleteCorrection = (row) => {
        let findings = [...this.props.findings];
        findings.forEach((finding) => {
            if (finding.number === row.findingNumber) {
                finding.corrections.forEach((correction, index) => {
                    if (correction.id === row.id) {
                        finding.corrections[index].toRemove = true;
                        this.showPopup("Komunikat", PropertyBucket.deleteCorrectionMessage(), "notify")
                    }
                })
            }
        });

        this.props.onCorrectionsChange(findings);
    };

    render() {
         let loadedCorrectionsData = this.prepareCorrectionsData(this.props.findings, this.props.orders);
         let table;
         let popUp;
        this.state.showPopup ?
            (popUp = <PopUp type={this.state.popUp.type}
                            title={this.state.popUp.title}
                            notification={this.state.popUp.notification}
                            link={this.state.popUp.link}
                            onClickEvent={this.state.popUp.onClickEvent}
                            closePopUp={this.handleClosePopUp}
            />) : null;

         if (loadedCorrectionsData.length >= 0) {

               table =  <TableCustom
                                columns={ this.state.columns }
                                data= {loadedCorrectionsData}

                                actions={[
                                   rowData => ({
                                       icon: 'editButton',
                                       iconProps: { style: { fontSize: "24px", color: "#0d47a1" } },
                                       tooltip: <span>Edytuj<span className='sr-only'> {rowData.name || ''}</span></span>,
                                       onClick: (event, rowData) => {
                                           this.onEditButtonClick(rowData);
                                       },
                                       disabled: !this.props.isSectionEdit("corrections")
                                   }),
                                   rowData => ({
                                       icon: 'delete',
                                       iconProps: { style: { fontSize: "24px", color: "#0d47a1" } },
                                       tooltip: <span>Usuń<span className='sr-only'> {rowData.name || ''}</span></span>,
                                       onClick: (event, rowData) => {
                                           this.onDeleteButtonClick(rowData);
                                       },
                                       disabled: !this.props.isSectionEdit("corrections")
                                   }),
                               ]}
                             />;
         }

         return (
                <div id="financial-correction">
                    <div>
                        {this.props.isSectionEdit("corrections") ? (<button className="btn save-btn" id="plus_img_container" onClick={this.onAddButtonClick} ><i data-v-db6946bc="" aria-hidden="true" className="v-icon material-icons theme--light v-list-text">add</i><span>DODAJ KOREKTĘ</span></button>) : (<button className="btn save-btn" style={{float: 'right'}} disabled={!this.props.isSectionEdit(null)} onClick={() => {
                            this.props.setSectionEdit("corrections");
                            this.props.makeFindingsCopy();

                        }}>EDYTUJ</button>)}
                        <div className="clearfix mb-3"></div>
                    </div>
                   {this.state.showWindow ? this.showActionsWindow() : null}
                   {popUp}
                   <div>
                        <div id="corrections_table" className={`${this.props.financialFindingsNotes ? 'mb-4' : ''}`}>
                              {table}
                        </div>
                    </div>
                    {this.props.financialFindingsNotes && this.props.financialFindingsNotes()}
                    <div>
                        <div className="btn_group" style={{display: 'flex', justifyContent: 'flex-end', gap: '8px'}}>
                            <button className="btn save-btn" disabled={!this.props.isSectionEdit("corrections")} onClick={() => {
                                this.props.saveCorrections();
                            }}>ZAPISZ</button>
                            {this.props.isSectionEdit("corrections") && (
                                <button className="btn cancel-btn" onClick={() => {
                                    this.props.setSectionEdit(null);
                                    this.props.restoreFindings();
                                }}>ANULUJ</button>
                            )}   
                        </div>
                    </div>
                </div>
            );
        }
    }


export default CreatePostControlInfoCorrections
